export default __webpack_public_path__ + "static/media/alternativo.266a4b1c.svg";